import { Injectable, Signal } from '@angular/core';
import { Model, ModelFacadeInterface } from '@web-portal/domains/shared/domain-models';

@Injectable()
export abstract class ModelFacadeStrategy<M = Model> implements ModelFacadeInterface<M> {
  abstract models: Signal<M[]>;
  /** Maximum 4 recent models sorted by changed/created date (newest first) */
  abstract recentModels: Signal<M[]>;
}
